export default __webpack_public_path__ + "static/media/back_b.615cf54b.jpg";